module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAYCAYAAADOMhxqAAAABGdBTUEAALGPC/xhBQAAAHxJREFUOBGVzMsNgCAQRVGQlmRvNYYutDQL0JbEDImEz3zfYlb3jHOG7SmdXttDnN98qMAfw3MRtLEIxpgFWEwCKkYBF09AijugiSvQxgVYYgALHMvCc9/XGqN32W0aGCCyoAIsqAIt6oAGTUBCKOAQCSjEAgyJYEQq0KIPDbJw4tTPUx8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img_triangle_light.png
// module id = 107
// module chunks = 1